'use client'

import React from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button } from '@workspace/ui/components/Button'
import { Home } from 'lucide-react'

function NotAuthorizedPage() {
    const navigate = useNavigate()

    const handleGoHome = () => {
        navigate({ to: '/' })
    }

    return (
        <div className="flex items-center justify-center flex-col p-4 bg-background">
            <div className="w-full max-w-[480px] flex flex-col items-center gap-6 text-center">
                <img
                    src="/not-authorize.png"
                    alt="Not authorize illustration"
                    className="h-full max-h-[360px] w-auto"
                />

                <div className="space-y-3">
                    <h1 className="text-4xl font-bold text-foreground">Không có quyền truy cập</h1>
                    <p className="text-base text-muted-foreground">
                        Bạn không có quyền truy cập. Vui lòng kiểm tra lại đường dẫn hoặc quay về trang chủ.
                    </p>
                </div>

                <Button variant="default" size="lg" onPress={handleGoHome} className="gap-2 mt-2">
                    <Home className="h-4 w-4" />
                    Về trang chủ
                </Button>
            </div>
        </div>
    )
}

export const Route = createFileRoute('/not-authorized')({
    component: NotAuthorizedPage,
})

export default NotAuthorizedPage
